"use strict";

const MuniCulvertGeoServerLayer = function () {
  const layerName = "muniCulvert";
  const layerKey = "muniCulvertLayer";

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const muniCulvertGeoServerLayer = new GeoServerMapLayer(layerName, layerKey);
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, muniCulvertGeoServerLayer);

    muniCulvertGeoServerLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    muniCulvertGeoServerLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    MuniCulvertPopup.invalidatePopupCache();
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await ApiCalls.getMuniCulverts();
    return _organizeLayerData(data);
  };

  var _organizeLayerData = function (layerData) {
    return layerData.map((data) => getOrganizedProperties(data));
  };

  var getOrganizedProperties = function (data) {
    return {
      id: data.id,
      groupId: data.group_id,
      name: data.name,
      cof: data.cof_final_text,
      material: data.material,
      culvertType: data.type,
      lineServiceType: data.line_service_type,
      icon: RoutineMaintenanceIcon.getMaintenanceIcon("muni-culvert", data.condition),
      installDate: data.install_date,
      lined: data.lined,
      correctiveAction: data.corrective_actions ? JSON.parse(data.corrective_actions) : null,
      enforcementLevel: data.severity ? JSON.parse(data.severity) : null,
      implementerType: data.implementer_type,
      responsiblePartyMaintenance: data.responsible_party_maintenance,
      property: data.property,
      phase: data.phase,
      accessible: data.accessible,
      shape: data.shape,
      condition: data.condition,
      diameter: data.diameter,
      diameterUnits: data.diameter_units,
      length: data.length,
      lengthUnits: data.length_units,
      width: data.width,
      widthUnits: data.width_units,
      catchment_names: data.catchment_names ? JSON.parse(data.catchment_names) : null,
      drains_to_rws: data.drains_to_rws ? JSON.parse(data.drains_to_rws) : null,
      drains_to_cs: data.drains_to_cs ? JSON.parse(data.drains_to_cs) : null,
      zone_names: data.zone_names ? JSON.parse(data.zone_names) : null,
      routine: DateTime.parseJsonIsoDateArray(data.routine_inspection_dates),
      repair: DateTime.parseJsonIsoDateArray(data.repair_dates),
    };
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    getLayerData,
    invalidateLayerData,
    _organizeLayerData,
  };
};

module.exports = MuniCulvertGeoServerLayer();

const GeoServerLayerFunctions = require("../../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../../mapFunctions/geoServerMapLayer");
const MuniCulvertPopup = require("./muniCulvertPopup");
const RoutineMaintenanceIcon = require("../../general/routineMaintenanceIcon");
const ApiCalls = require("../../apiCalls");
const DateTime = require("../../dateTime");
